import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/api/auth";
import { ApiClientError } from "@/api/client";
import { queryKeys } from "@/lib/query-keys";

export function useMe() {

    return useQuery({
        queryKey: queryKeys.auth.me(),
        queryFn: async () => {

            try {

                return await authApi.me();
            } catch (err) {

                if (err instanceof ApiClientError && err.status === 401)
                    return null;

                throw err;
            }
        },
        staleTime: 5 * 60 * 1000,
        retry: false,
    });
}
